<template>
    <div>
        <Toolbar>
            <BackButton :to="__('subscriptions.bundles')" :href="$route('subscriptions.bundles')"/>
        </Toolbar>

        <Card>
            <template v-slot:title>Create bundle</template>

            <div class="d-flex flex-column gap-3">
                <div>
                    <label class="font-weight-bold">Name</label>
                    <div>
                        <TranslatableForm type="name" v-model="bundle.translations"/>
                    </div>
                </div>
                <div>
                    <label class="font-weight-bold">Description</label>
                    <div>
                        <TranslatableForm type="description" v-model="bundle.translations"/>
                    </div>
                </div>
                <div>
                    <label class="font-weight-bold">Features</label>
                    <div>
                        <div v-for="feature in features">
                            {{ feature.lang.name }}
                        </div>
                    </div>
                </div>
                <div>
                    <label class="font-weight-bold">Base price</label>
                    <div>
                        ...
                    </div>
                </div>
            </div>

            <template v-slot:footer>
                <button class="btn btn-primary">
                    {{ __('actions.create') }}
                </button>
            </template>
        </Card>
    </div>
</template>

<script>
import BackButton from "@components/BackButton.vue";
import Toolbar from "@components/Toolbar.vue";
import Card from "@components/Cards/Card.vue";
import TranslatableForm from "@components/Subscriptions/TranslatableForm.vue";

export default {
    components: {TranslatableForm, Card, Toolbar, BackButton},

    props: {
        features: Array
    },

    data() {
        return {
            bundle: this.$inertia.form({
                translations: []
            })
        }
    }
}
</script>
